import {
    FinanceLabField,
    FinanceLabFieldType,
} from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { SummaryRowConfig } from "../SummaryFinancials.types";

export const rowConfig: SummaryRowConfig[] = [
    {
        label: "Revenue",
        codes: [
            AccountLabel.REVENUES,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 0,
    },
    {
        label: "Gross Margin %",
        codes: [
            AccountLabel.GROSS_MARGIN,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
        ],
        fieldType: FinanceLabFieldType.PERCENTAGE,
        indentLevel: 0,
    },
    {
        label: "EBITDA",
        codes: [
            AccountLabel.EBITDA,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 0,
    },
    {
        label: "EBITDA Margin %",
        codes: [
            AccountLabel.EBITDA_MARGIN,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
        ],
        fieldType: FinanceLabFieldType.PERCENTAGE,
        indentLevel: 0,
    },
    {
        label: "Sales & Marketing Efficiency",
        codes: [
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY,
        ],
        fieldType: FinanceLabFieldType.MULTIPLE,
        indentLevel: 0,
    },
    {
        label: "Net Income",
        codes: [
            AccountLabel.NET_INCOME,
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
        ],
        fieldType: FinanceLabFieldType.CURRENCY,
        indentLevel: 0,
    },
    {
        label: "Net Income Margin %",
        codes: [
            FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
        ],
        fieldType: FinanceLabFieldType.PERCENTAGE,
        indentLevel: 0,
    },
];
